import type { IntlShape } from "react-intl";
import type { UserRoles } from "~enums/userRoles";
import { userRolesConfig } from "../../constants/userRolesConfig";
import { PermissionProducts } from "../../enums/permissionProducts";
import type { UserRoleSelectOption } from "../types";

const getUserRoleSelectOptionsByProduct = (
  formatMessage: IntlShape["formatMessage"],
): Record<PermissionProducts, UserRoleSelectOption[]> => {
  const initialValue: Record<PermissionProducts, UserRoleSelectOption[]> = {
    [PermissionProducts.Competitions]: [],
    [PermissionProducts.TeamManager]: [],
  };

  return Object.entries(userRolesConfig).reduce<Record<PermissionProducts, UserRoleSelectOption[]>>(
    (accumulator, [userRole, roleConfig]) => {
      const roleSelectOption: UserRoleSelectOption = {
        value: userRole as UserRoles,
        label: formatMessage({ id: `permissions.userRole.${userRole}` }),
      };
      accumulator[roleConfig.product].push(roleSelectOption);
      return accumulator;
    },
    initialValue,
  );
};

export default getUserRoleSelectOptionsByProduct;
